import React, { useMemo } from 'react';

import { AutoComplete, type AutoCompleteProps } from 'antd';
import { useGetModulesQuery } from 'src/redux/services/centralApi';

export default function SelectTarget(
	{
		...props
	}: AutoCompleteProps
) {

	const {
		data,
	} = useGetModulesQuery({});

	const targetOptions = useMemo(() => {
		if(!data) return [];

		const targetList: string[] = [];
		data.forEach(module => {
			if(!targetList.includes(module.target)){
				targetList.push(module.target);
			}
		});

		return targetList.map(target => ({
			value: target,
			label: target,
		}));
	}, [ data, ]);

	return (
		<AutoComplete
			placeholder={'ERP'}
			options={targetOptions}
			{...props}
		/>
	);
}
